const data = {
    1: 'Agriculture, Food, & Natural Resources',
    2: 'Architecture & Construction',
    3: 'Arts, Media, & Communication',
    4: 'Business Management & Administration',
    5: 'Education',
    6: 'Finance',
    7: 'Government, Military, & Public Administration',
    8: 'Health Science',
    9: 'Hospitality & Tourism',
    10: 'Human Services',
    11: 'IT & Computer Science',
    12: 'Law & Public Safety',
    13: 'Manufacturing & Manual Operations',
    14: 'Marketing & Sales',
    15: 'Science, Engineering & Mathematics',
    16: 'Transportation, Distribution & Logistics',
};

module.exports = data;



// WEBPACK FOOTER //
// ./src/client/utils/subjectAreas.js